fx.ns("models", class CreationElement extends fx.Model {

    /**
     * Set single to true when creating a page with only one side (basic layouts)
     * @param {*} data 
     * @param {*} single 
     */
    constructor(data) {
        super(data);
        this._photoContents = [];
        this._generating = false;
        this._wasModified = false;
    }

    get isCover() {
        return this.typeid == 6;
    }

    get creation() {
        return this.parent;
    }

    get width() {
        return this.creation.pageWidth;
    }

    get height() {
        return this.creation.pageHeight;
    }

    get generating()
    {
        return this._generating;
    }

    set generating(val)
    {
        this._generating = val;
    }

    get modified()
    {
        return super.modified;
    }

    // wasModified is used for case when we generate image of cover
    // but while we generate, cover is updated
    // so we need to store the fact that cover was upated while being generated
    // so it's still set as modified when cover is generated, so it will be generated again.
    set modified(val)
    {
        if (!val && this._wasModified)
        {
            super.modified = this._wasModified;
            this._wasModified = false;
        }
        else
            super.modified = val;

        if (this.generating && val)
            this._wasModified = val;
    }

    get wasModified()
    {
        return this._wasModified;
    }

    // set here default values that will be used when creating new model
    get defaults() {
        return {
            id: Utils.newID(),
            bgcolor: "#ffffff",
            bgcolorleft: "#ffffff",
            bgcolorright: "#ffffff",
            fontsize: 20,
            layoutid: -1,
            number: 0,
            quantity: 1,
            textcolor: "#000000",
            typeid: 1,
            components: [],
            hasbackcover: 0
        };
    }

    get propertiesNotStorable() {
        return ["id", "thumb", "thumb_generated", "shape", "components"];
    }

    get maxLevel() {
        let level = 0;
        for (let i = 0; i < this.components.length; i++)
            if (this.components.content_type != "slice_text")
                level = Math.max(level, this.components.getItemAt(i).level);
        return level;
    }

    get lostBorder() {
        return 5;
    }

    get isEmpty() {
        let empty = (this.components.length <= (this.isCover ? 3 : 2));

        // so only backgrounds
        if (empty) {
            for (let i = 0; i < this.components.length; i++) {
                let component = this.components.getItemAt(i);
                empty = empty && (component.content == "" && component.bgcolor == "#FFFFFF");
            }
        }

        return empty;
    }

    get sortedComponents() {
        return this.components.sort(this.componentsSort);
    }

    delete(history) {
        if (this.components)
            this.components.removeAll(false, history);

        super.delete(history);
    }

    label() {
        return this.number.toString();
    }

    getComponent(id) {
        return this.components.find({ id: id });
    }

    getTexts(creation) {
        if (!creation)
            creation = "";

        let texts = [];
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (!component.deleted && component.isText && (!creation || component.creation == creation))
                texts.push(component);

        }
        return texts;
    }

    getBackground(side) {
        //if (!side)
        //    side = "";

        let bg;
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (!component.deleted && component.isBackground && (side ? component.creation == side : true)) {
                bg = component;
                break;
            }
        }

        return bg;
    }

    getBackgrounds(side) {
        if (!side)
            side = "";

        let bgs = [];
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (!component.deleted && component.isBackground) {
                if (!side || component.creation == side)
                    bgs.push(component);
            }


        }
        return bgs;
    }

    getStickers() {
        let stickers = [];
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isSticker && component.content !== "")
                stickers.push(component);

        }
        return stickers;
    }

    getPhotos() {
        let photos = [];
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isPhoto)
                photos.push(component);

        }
        return photos;
    }


    get mediaComponents() {
        let medias = [];
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (component.isBackground || component.isPhoto || component.isSticker) {
                //if (component.content != "")
                medias.push(component);
            }
        }
        return medias;
    }

    get textComponents() {
        let medias = [];
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (component.isText)
                medias.push(component);
        }
        return medias;
    }

    get photosComponents() {
        let medias = [];
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (component.isPhoto)
                medias.push(component);
        }
        return medias;
    }

    removeAllContent() {
        let medias = [];
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);
            if (component.isPhoto || component.isText || component.isSticker)
                medias.push(component);

            if (component.isBackground) {
                component.content = "";
                component.bgcolor = "#fff";
            }
        }

        let media;
        while (media = medias.pop())
            media.delete();
    }

    removeAllComponents() {
        let toDelete = [];
        for (var i = 0; i < this.components.length; i++) {
            if (!this.components.getItemAt(i).isBackground)
                toDelete.push(this.components.getItemAt(i));
        }
        for (var i = 0; i < toDelete.length; i++) {
            this.components.getItemAt(this.components.indexOf(toDelete[i])).delete();
        }
    }

    addComponent(data, side, width, height, layout, keepDesign) {
        data.creation_element_id = this.id;
        // background is a special case :
        if (data.component_type == "background") {
            let background = this.getBackground();
            if (!background) {
                this.addBackground();
                background = this.getBackground();
            }

            if (background)
                background.update({ content: data.content, bgcolor: data.bgcolor });

        }
        else // sticker / photo /shape / text / other
        {
            // For text, set position and check background color so we can set text color to opposite
            if (data.component_type == "text") {
                if (!layout && data.x === undefined) {
                    data.x = (width - data.width) / 2;
                    data.y = (height - data.height) / 2;
                }

                // Change text color depending on background color
                if (!layout) {
                    let color = "#ffffff";
                    let background = this.getBackground();

                    // Temporary fix : case when some background is missing :(
                    if (!background) {
                        this.addBackground();
                        background = this.getBackground();
                    }

                    color = (background.content ? background.text_color : background.bgcolor); // we store in text_color the average color of the background image
                    color = tinycolor(color);

                    if (color.toRgbString() == data.text_color) {
                        if (color.isDark())
                            color.brighten(color.getBrightness() > 20 ? 40 : 90);
                        else
                            color.darken(color.getBrightness() > 240 ? 70 : 20);

                        data.content = data.content.replace(/rgb\((\d+),\s(\d+),\s(\d+)\)/g, color.toRgbString());
                        data.text_color = color.toRgbString(); //"#ffffff";

                    }
                }


            }
            else
                if (data.component_type == "photo" && data.x === undefined) // added without position, need to be centered
                {
                    // TODO : why data.componentWidth & data.componentHeight don't exit ?
                    /*if (data.componentWidth > data.componentHeight)
                    {
                        data.width = width * 0.75;
                        data.height = data.componentHeight * data.width / data.componentWidth;
                    }
                    else
                    {
                        data.height = height * 0.75;
                        data.width = data.componentWidth * data.height / data.componentHeight;
                    }*/

                    data.x = (width - data.width) / 2;
                    data.y = (height - data.height) / 2;

                    //delete(data.componentWidth);
                    //delete(data.componentHeight);
                }


            data.id = Utils.newID();
            data.level = this.maxLevel + 1;

            let index = this.components.length;

            if (data.component_type == "photo" && keepDesign) {
                for (let i = 0; i < this.components.length; i++) {
                    if (this.components.getItemAt(i).component_type == "background")
                        index = i;
                }

            }
            
            data.level = index + 1;
            let component = new models.CreationElementContent(data);
            
            for (let i = index + 1; i < this.components.length; i++)
                this.components.getItemAt(i).level++;

            this.components.addItemAt(index + 1, component);
        }
    }

    addBackground() 
    {
        let background = this.getBackground();

        if (!background)
        {
            background = new models.CreationElementContent({ creation_element_id: this.id, creation: "", component_type: "background", bgcolor: this.bgcolorleft, align: "" });
            this.components.addItemAt(0, background);
        }
        
        return background;
    }


    // TODO get layout with photo from same ratio horizontal & vertical
    addPhoto(photos, width, height, layout, keepDesign) {
        this.applyLayout(layout, width, height, keepDesign);

        let photosComponents = this.photosComponents;

        for (let i = 0; i < photosComponents.length; i++) {
            let photo = photos.shift();
            if (photo)
                photosComponents[i].content = photo.id;
        }
    }

    applyBackground(background) {
        let bg = this.getBackground();
        if (bg)
            bg.update({ content: background.content, bgcolor: background.bgcolor });
    }

    applyLayout(layout, width, height, keepDesign) {
        this._photoContents = this._photoContents.filter(function (component) {
            return component.content != "";
        });

        // 1 - Remove all component, except backgrounds
        let existingComponents = this.components.toArray();

        while (existingComponents.length > 0) {
            let component = existingComponents.pop();

            if (component.isPhoto && component.content != "" && this._photoContents.find({ content: component.content }) == null)
                this._photoContents.unshift(component);

            if (!component.isBackground) // let's test also if need to delete all component, or only component from one side
            {
                if (!keepDesign || component.isPhoto || component.isSticker || component.isShape)
                    component.delete();
            }

        }

        let layoutBackground = layout.getBackground();
        let bg = this.getBackground();

        //if (!layout.isBasic)
        //{
        if (bg && layoutBackground)
            bg.update({ content: layoutBackground.content, bgcolor: layoutBackground.bgcolor });
        //}

        for (let i = 0; i < layout.components.length; i++) {
            let layoutComponent = layout.components.getItemAt(i).JSON();

            if (layoutComponent.component_type != "background") {
                if (layoutComponent.component_type == "photo")
                    layoutComponent.content = "";

                this.addComponent(layoutComponent, width, height, true, keepDesign);
            }
        }


        // ---> SET PHOTOS content
        // sort photoContent from left to right, and components from left to right
        // and then apply content

        let components = this.components.filter(function (component) {
            return component.isPhoto && !component.deleted;
        });


        this._photoContents.sort(function (a, b) {
            let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
            let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
            return bounding1.x - bounding2.x;
        })

        components.sort(function (a, b) {
            let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
            let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
            return bounding1.x - bounding2.x;
        })

        let index = 0;
        for (let i = 0; i < components.length && index < this._photoContents.length; i++) {
            let photoContent = this._photoContents[index];

            let tempId = Utils.temporaryId(photoContent.content);
            components[i].content = tempId ? tempId : photoContent.content;
            index++;
        }

        this.delay(this._cleanPhotoContent, 30000);
    }


    extractLayout(side, pageWidth) {
        let layout = new models.ThemeLayout({});

        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);

            if (!component.isBackground) {
                let json = component.JSON();
                delete (json.id);
                delete (json.creation_element_id);

                if (json.component_type == "photo")
                    json.content = "";


                layout.components.addItem(new models.ThemeLayoutComponent(json));
            }

        }

        layout.update({ height: this.creation.pageHeight, width: this.creation.pageWidth });

        return layout;
    }

    updateBackgroundColor(color, removeContent) {
        let bg = this.getBackground();
        if (!bg)
            bg = this.addBackground();

        bg.update({ content: removeContent ? "" : bg.content, bgcolor: color });

        this.bgcolor = color;
    }

    onUpdated(action) {
        if (!action.history) {
            if (action.tag == "update-level-up")
                this.updateLevels(action.model, false);

            if (action.tag == "update-level-down")
                this.updateLevels(action.model, true);
        }

        // if id of page is updated, let's update all component pageid
        if (action.impacts("id") && action.model == this) {
            for (let i = 0; i < this.components.length; i++) {
                let component = this.components.getItemAt(i);
                component.creation_element_id = this.id;
            }
        }

/*        // use to know if page was updated
        if (action.type == "create" || action.type == "update" || action.type == "delete")
            this.modified = true;
*/
        // fix to avoid having background with "manual"
        if (action.model instanceof models.CreationElementContent) {
            if (action.model.component_type == "background" && action.impacts("creation")) {
                if (action.data.creation == "manual")
                    action.model.creation = action.previous.creation;
            }
        }

    }
    


    //********************* PRIVATE *********************/

    updateLevels(component, down) {
        if (down)
            this.components.moveItem(component, this.getBackgrounds().length);
        else
            this.components.moveItem(component, this.components.length - 1);

        for (let i = 0; i < this.components.length; i++)
            this.components.getItemAt(i).level = i;
    }

    _cleanPhotoContent() {
        this._photoContents = [];
        this._photoContents.side = "";
    }

    componentsSort(a, b) {

        // background
        if (a.isBackground && !b.isBackground)
            return -1;

        if (!a.isBackground && b.isBackground)
            return 1;

        if (a.isBackground && b.isBackground)
            return 0;

        // calendar
        if (a.isCalendar && !b.isCalendar)
            return -1;

        if (!a.isCalendar && b.isCalendar)
            return 1;

        if (a.isCalendar && b.isCalendar)
            return 0;
        
        if (a.level < b.level)
            return -1;

        if (a.level > b.level)
            return 1;

        return 0;
    }



    removeSticker(id)
    {
        let stickers = this.getStickers();
        for(let i = 0; i < stickers.length; i++)
        {
            if (stickers[i].content == id)
                stickers[i].delete();
        }
    }

    removeBackground(id)
    {
        let backgrounds = this.getBackgrounds();
        for(let i = 0; i < backgrounds.length; i++)
        {
            if (backgrounds[i].content == id)
                backgrounds[i].delete();
        }
    }

});